import React, { useContext, useState } from "react";
import { API_URL } from "../components/api";
import { styled, alpha } from "@mui/material/styles";
import AuthContext from "../context/AuthContext";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import Axios from "axios";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,

    maxWidth: "180px !important", // Updated: Added !important to force the width
    width: "auto !important", // Updated: Added !important to override global styles
    maxHeight: "300px", // LIMIT HEIGHT
    overflowY: "auto", // MAKE SCROLLABLE
    scrollbarWidth: "thin", // Firefox
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#aaa",
      borderRadius: "10px",
    },
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
      "&:hover": {
        color: "white",
      },
    },
  },
}));

export default function CustomizedActions(props) {
  const [message, setMessage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [Action, setAction] = useState("");
  const [openy, setOpeny] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [deactivateInfo, setDeactivateInfo] = useState([]);
  const [freeSubs, setFreeSubs] = useState([]);
  const freePopup =
    ["Recharge", "Activate", "Reset"].includes(Action) && freeSubs.length > 0;
  const freeLine = (f) =>
    document.documentElement.lang === "ar"
      ? `${f.username} لديه حساب مجاني`
      : `${f.username} has a free account`;
  const isDeactivateAllSkipped = () =>
    Action === "Deactivate" &&
    props.subscriptions &&
    props.subscriptions.length > 0 &&
    props.subscriptions.every((id) =>
      deactivateInfo.some(
        (d) => String(d.subscription_id) === String(id) && d.skipped_status
      )
    );
  const deactivateLine = (d) => {
    const ar = document.documentElement.lang === "ar";
    if (d.skipped_status) {
      return ar
        ? `${d.username} ${d.skipped_status === "deleted" ? "محذوف" : "غير مفعّل"} أصلاً — لا شيء لإلغاء تفعيله.`
        : `${d.username} is already ${d.skipped_status} — nothing to deactivate.`;
    }
    const amt = `$${Number(d.amount)}`;
    const days =
      d.days === null
        ? ar ? "لا يوجد تاريخ دفع" : "no payment date"
        : d.days < 0
        ? ar ? "لم يحن موعد الدفع بعد" : "not yet due"
        : ar ? `${d.days} يوم بعد تاريخ الدفع` : `${d.days} days after the payment date`;
    if (d.days === null) {
      return ar
        ? `${d.username}: ${days} — الفاتورة #${d.invoice_id} (${amt}) تبقى كما هي.`
        : `${d.username}: ${days} — invoice #${d.invoice_id} (${amt}) is left as is.`;
    }
    if (d.late) {
      return d.paid
        ? ar
          ? `${d.username} دفع الشحن التلقائي ${amt} (${days}) — لا استرداد.`
          : `${d.username} already paid the system recharge of ${amt} (${days}) — no refund.`
        : ar
          ? `${d.username} متأخر (${days}) ويجب أن يدفع الشحن التلقائي ${amt} (فاتورة #${d.invoice_id}).`
          : `${d.username} is late (${days}) and must pay the system recharge of ${amt} (invoice #${d.invoice_id}).`;
    }
    if (!d.paid) {
      return ar
        ? `${d.username} لم يدفع الشحن التلقائي ${amt} (${days}) — سيتم إلغاء الفاتورة #${d.invoice_id}، لا استرداد.`
        : `${d.username} has not paid the system recharge of ${amt} (${days}) — invoice #${d.invoice_id} will be cancelled, nothing refunded.`;
    }
    if (d.receipt_id) {
      return ar
        ? `${d.username} دفع الشحن التلقائي ${amt} (${days}) — سيتم إلغاء الإيصال #${d.receipt_id} والفاتورة #${d.invoice_id} واسترداد ${amt}.`
        : `${d.username} already paid the system recharge of ${amt} (${days}) — receipt #${d.receipt_id} and invoice #${d.invoice_id} will be cancelled and ${amt} refunded.`;
    }
    return ar
      ? `${d.username} دفع الشحن التلقائي ${amt} (${days}) — الإيصال يغطي فواتير أخرى، ألغِه يدوياً؛ الفاتورة #${d.invoice_id} لن تُلغى.`
      : `${d.username} already paid the system recharge of ${amt} (${days}) — the receipt covers other invoices, cancel it manually; invoice #${d.invoice_id} will not be cancelled.`;
  };
  const discountLine = (d) =>
    document.documentElement.lang === "ar"
      ? `${d.username} لديه خصم بقيمة ${Number(d.amount)} (${Number(d.percentage)}%)`
      : `${d.username} has a discount of ${Number(d.amount)} (${Number(d.percentage)}%)`;
  const [reason, setReason] = useState("");
  const [selectedNumber, setSelectedNumber] = useState(1); // State for selected number
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOpenpop = () => {
    setOpeny(true);
    setDiscounts([]);
    setFreeSubs([]);
    if (!props.subscriptions || props.subscriptions.length === 0) return;
    Axios.get(`${API_URL}/radius/subscriptions/discounts/`, {
      headers: { Authorization: `Bearer ${authTokens.access}` },
      params: {
        username: user.username,
        subscription_ids: props.subscriptions.join(","),
      },
    })
      .then((response) =>
        setDiscounts(Array.isArray(response.data) ? response.data : [])
      )
      .catch(() => setDiscounts([]));
    Axios.post(
      `${API_URL}/radius/subscriptions/bulkactions/`,
      {
        Action: "FreeCheck",
        free_mode: "check",
        sub_id: props.subscriptions,
        userdealer: user.username,
        reason: "",
      },
      { headers: { Authorization: `Bearer ${authTokens.access}` } }
    )
      .then((response) =>
        setFreeSubs(
          Array.isArray(response.data && response.data.free) ? response.data.free : []
        )
      )
      .catch(() => setFreeSubs([]));
    setDeactivateInfo([]);
    Axios.get(`${API_URL}/radius/subscriptions/deactivate-preview/`, {
      headers: { Authorization: `Bearer ${authTokens.access}` },
      params: { subscription_ids: props.subscriptions.join(",") },
    })
      .then((response) =>
        setDeactivateInfo(Array.isArray(response.data) ? response.data : [])
      )
      .catch(() => setDeactivateInfo([]));
  };

  const handleClosepop = () => {
    setOpeny(false);
    setReason(""); // Clear reason on close
    setSelectedNumber(1); // Reset selected number on close
  };

  const sendAction = (id) => {
    setAction(id);
  };

  const confirmAction = async () => {
    const receiptNotes = [];
    if (Action === "Deactivate") {
      const receipts = deactivateInfo.filter(
        (d) => d.paid && d.receipt_id && !d.late
      );
      for (const d of receipts) {
        try {
          await Axios.post(
            `${API_URL}/inventory/receipt/cancel/`,
            { receipt_id: d.receipt_id, reason: reason },
            { headers: { Authorization: `Bearer ${authTokens.access}` } }
          );
          receiptNotes.push(`Receipt #${d.receipt_id} (${d.username}) cancelled.`);
        } catch (error) {
          showMessage(
            (error.response && error.response.data && error.response.data.message) ||
              `Receipt #${d.receipt_id} could not be cancelled.`,
            "error"
          );
          return;
        }
      }
    }
    SubmitAction(receiptNotes.join(" "));
  };

  const SubmitAction = async (prefix = "", freeMode = null) => {
    Axios.post(
      `${API_URL}/radius/subscriptions/bulkactions/`,
      {
        Action: Action,
        sub_id: props.subscriptions,
        userdealer: user.username,
        reason: reason, // Pass the reason to the backend
        selectedNumber: Action === "Reactivate" ? selectedNumber : null, // Pass the selected number if action is Reactivate
        ...(freeMode ? { free_mode: freeMode } : {}),
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        props.deselect();
        props.fetch();
        showMessage(prefix ? prefix + " " + response.data : response.data, "success");
      })
      .catch((error) => {
        console.log(error);
        showMessage("Action failed!", "danger");
      });
  };

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });
    setTimeout(() => setMessage(null), 5000);
  };

  return (
    <div className="test">
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        style={{
          backgroundColor: "transparent",
          height: "18px",
          padding: "10px",
        }}
        disableElevation
        onClick={handleClick}
      >
        <i className="fas fa-bolt"> </i> Actions
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Recharge");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Recharge
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Activate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Activate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Deactivate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Deactivate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Reset");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Reset Quota
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Disconnect");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Disconnect
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Hold");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Hold
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("HSI");
            handleClickOpenpop();
          }}
          disableRipple
        >
          HSI
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Push");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Push
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Generate");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Generate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Delete");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Reset Mac");
            handleClickOpenpop();
            setReason("");
          }}
          disableRipple
        >
          Reset Mac
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Reactivate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Reactivate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Free");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Free
        </MenuItem>
      </StyledMenu>
      <Dialog
        open={openy}
        onClose={handleClosepop}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {isDeactivateAllSkipped()
            ? document.documentElement.lang === "ar"
              ? "لا شيء لإلغاء تفعيله"
              : "Nothing to deactivate"
            : freePopup
            ? document.documentElement.lang === "ar"
              ? "حساب مجاني"
              : "Free account"
            : `Are you sure you want to ${Action}?`}
        </DialogTitle>
        {freePopup && (
          <DialogContent>
            {freeSubs.map((f) => (
              <DialogContentText key={f.subscription_id}>
                {freeLine(f)}
              </DialogContentText>
            ))}
          </DialogContent>
        )}
        {isDeactivateAllSkipped() && (
          <DialogContent>
            {deactivateInfo.map((d) => (
              <DialogContentText key={d.subscription_id}>
                {deactivateLine(d)}
              </DialogContentText>
            ))}
          </DialogContent>
        )}
        {discounts.length > 0 && (
          <DialogContent>
            {discounts.map((d) => (
              <DialogContentText key={d.discount_id}>
                {discountLine(d)}
              </DialogContentText>
            ))}
          </DialogContent>
        )}

        {/* Check if Action requires a reason */}
        {(Action === "Activate" ||
          Action === "Deactivate" ||
          Action === "Hold") &&
          !isDeactivateAllSkipped() && (
          <DialogContent>
            {Action === "Deactivate" &&
              deactivateInfo.map((d) => (
                <DialogContentText key={d.invoice_id}>
                  {deactivateLine(d)}
                </DialogContentText>
              ))}
            <DialogContentText>
              Please provide a reason for the action.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              variant="standard"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </DialogContent>
        )}
        {Action === "Recharge" && (
          <DialogContent>
            <DialogContentText>
              That would be {props.totalSellingPrice} Dollars
            </DialogContentText>
          </DialogContent>
        )}
        {Action === "Reset" && (
          <DialogContent>
            <DialogContentText>
              That would be {props.totalResetQuotaPrice} Dollars
            </DialogContentText>
          </DialogContent>
        )}
        {Action === "Reactivate" && (
          <DialogContent>
            <DialogContentText>
              Select a number between 1 and 5:
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              variant="standard"
              type="number"
              inputProps={{ min: 1, max: 5 }}
              value={selectedNumber}
              onChange={(e) => setSelectedNumber(parseInt(e.target.value))}
            />
          </DialogContent>
        )}
        <DialogActions>
          {isDeactivateAllSkipped() ? (
            <Button onClick={handleClosepop} autoFocus>
              {document.documentElement.lang === "ar" ? "حسناً" : "OK"}
            </Button>
          ) : freePopup ? (
            <>
              <Button onClick={handleClosepop} style={{ marginRight: "auto" }}>
                {document.documentElement.lang === "ar" ? "إلغاء" : "Cancel"}
              </Button>
              <Button
                onClick={() => {
                  handleClosepop();
                  SubmitAction("", "free");
                }}
                disabled={Action === "Activate" && !reason}
                autoFocus
              >
                {document.documentElement.lang === "ar" ? "حسناً" : "OK"}
              </Button>
              <Button
                onClick={() => {
                  handleClosepop();
                  SubmitAction("", "bill");
                }}
                disabled={Action === "Activate" && !reason}
              >
                {document.documentElement.lang === "ar" ? "فوترة على أي حال" : "Bill anyway"}
              </Button>
            </>
          ) : (
            <>
          <Button onClick={handleClosepop}>No</Button>
          <Button
            onClick={() => {
              handleClosepop();
              confirmAction();
            }}
            // Disable the button if a reason is required but not provided
            disabled={
              (Action === "Activate" ||
                Action === "Deactivate" ||
                Action === "Hold") &&
              !reason
            }
            autoFocus
          >
            Yes
          </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}
